import axios from 'axios';
import { fetchAuthSession } from 'aws-amplify/auth';

const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
  timeout: 10000,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use(async config => {
  try {
    const session = await fetchAuthSession();
    const token   = session.tokens?.idToken?.toString();
    if (token) config.headers.Authorization = `Bearer ${token}`;
  } catch {
    // unauthenticated request — no token added
  }
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    const message = err.response?.data?.error?.message ?? err.message ?? 'An error occurred';
    return Promise.reject(new Error(message));
  }
);

export default api;
